import { axiosInstance } from "@/api/apiClient";
import {
  PaymentsApi,
  PaymentsApiPaymentsViewsNinjaPurchaseUnprovisionedPaymentsRequest,
} from "@/api/client";
import { BASE_API } from "@/helpers/constants";

const api = new PaymentsApi(undefined, BASE_API, axiosInstance);

export const getUnprovisionedPayment = async (
  payload: PaymentsApiPaymentsViewsNinjaPurchaseUnprovisionedPaymentsRequest = {}
) => {
  return api.paymentsViewsNinjaPurchaseUnprovisionedPayments.bind(api)(payload);
};
